module.exports = __webpack_public_path__ + "static/img/solutionText15.3d157a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText15.png
// module id = mQve
// module chunks = 1